/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_welcome_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome Back`)
};

const zh_hans1_login_welcome_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎回来`)
};

const zh_hant1_login_welcome_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歡迎回來`)
};

const fr_login_welcome_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bon retour`)
};

const de_login_welcome_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen zurück`)
};

const ja_login_welcome_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おかえりなさい`)
};

const ko_login_welcome_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 오신 것을 환영합니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_welcome_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_welcome_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_welcome_title", locale)
	if (locale === "en") return en_login_welcome_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_welcome_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_welcome_title(inputs)
	if (locale === "fr") return fr_login_welcome_title(inputs)
	if (locale === "de") return de_login_welcome_title(inputs)
	if (locale === "ja") return ja_login_welcome_title(inputs)
	return ko_login_welcome_title(inputs)
};